module.exports = __webpack_public_path__ + "a54aba83b3d5d7702890c07c31c48147.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/BoldItalic/OpenSans-BoldItalic.svg?v=1.1.0
// module id = 1011
// module chunks = 0